import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import {
  VContainer,
  VRow,
  VSheet,
  VFadeTransition,
  VOverlay,
  VProgressCircular,
  VCard,
  VCardTitle,
  VCardText,
  VCardActions,
  VSlideGroup,
  VSlideGroupItem,
  VImg,
  VSpacer,
  VBtn,
  VIcon,
  VSkeletonLoader,
} from 'vuetify/components'
import { Intersect } from 'vuetify/directives'

export default createVuetify({
  components: {
    VContainer,
    VRow,
    VSheet,
    VFadeTransition,
    VOverlay,
    VProgressCircular,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
    VSlideGroup,
    VSlideGroupItem,
    VImg,
    VSpacer,
    VBtn,
    VIcon,
    VSkeletonLoader,
  },
  directives: {
    Intersect,
  },
})
